import { render, staticRenderFns } from "./SkuAdd.vue?vue&type=template&id=c44e776e"
import script from "./SkuAdd.vue?vue&type=script&lang=js"
export * from "./SkuAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports